import { THEME_PRIMARY, themeColor } from '../../../../styles/basics/colors';

function createInnerDragElement(dragLabel: string, className: string) {
    const innerDragElement = document.createElement('span');
    innerDragElement.innerText = dragLabel;
    innerDragElement.className = className;
    innerDragElement.style.alignItems = 'center';
    innerDragElement.style.overflow = 'hidden';
    innerDragElement.style.textOverflow = 'ellipsis';
    innerDragElement.style.whiteSpace = 'nowrap';
    innerDragElement.style.fontSize = '12px';
    innerDragElement.style.fontWeight = 'bold';
    innerDragElement.style.padding = '0 8px';
    innerDragElement.style.border = `1px solid ${themeColor(THEME_PRIMARY)}`;
    return innerDragElement;
}

export function createDragElement(dragLabel: string, className = 'drag-ghost') {
    const dragContainer = document.createElement('div');
    dragContainer.className = className;
    dragContainer.style.display = 'inline-flex';
    dragContainer.style.backgroundColor = 'white';
    dragContainer.style.height = '20px';
    dragContainer.style.maxWidth = '250px';
    dragContainer.style.minWidth = '0';

    const innerDragElement = createInnerDragElement(dragLabel, className);

    dragContainer.appendChild(innerDragElement);

    return dragContainer;
}
